import { PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle } from '@systemeio/ui'
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link'
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import { cashOnDeliveryConnect } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/api'
import {
  CashOnDeliveryCreateIntegrationInterface,
  CashOnDeliveryErrorsIntegrationInterface,
} from 'modules/profile/payment-gateways/integrations/cash-on-delivery/types'
import { getCashOnDeliveryHelpPageLink } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/utils'
import React, { useState } from 'react'
import CreateModal from 'shared/components/create-modal'
import FormTextarea from 'shared/components/form-textarea'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { fetchWithErrors } from 'shared/utils/fetch-with-errors'

const defaultValues: CashOnDeliveryCreateIntegrationInterface = {
  instructions: '',
}

const defaultErrors: CashOnDeliveryErrorsIntegrationInterface = {
  instructions: '',
}

const CashOnDeliveryCreateModal = () => {
  const { t } = useLocoTranslation()
  const { user } = useUser()
  const [opened, setOpened] = useState(false)
  const [errors, setErrors] = useState(defaultErrors)

  const { mutatePaymentIntegrations } = useConnectedPaymentIntegrations()

  const onCreate = async (data: CashOnDeliveryCreateIntegrationInterface) => {
    await fetchWithErrors(async () => {
      await cashOnDeliveryConnect(data)
      await mutatePaymentIntegrations()
    }, setErrors)
  }

  return (
    <>
      <PrimaryButton
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          setOpened(true)
        }}
        className={'font-bold'}
      >
        {t('dashboard.settings.payment_gateways.connect')}
      </PrimaryButton>
      <CreateModal
        fullCaption={t('dashboard.settings.payment_gateways.connect_cash_on_delivery_payment')}
        caption={getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery)}
        needToast={false}
        opened={opened}
        onClose={() => setOpened(false)}
        defaultValues={defaultValues}
        creatable={[
          {
            field: 'instructions',
            onRender: (value, onChange) => (
              <FormTextarea
                key="cash-on-delivery-create-instructions"
                onChange={e => onChange(e.target.value)}
                label={t('dashboard.settings.payment-gateways.instructions_title')}
                value={value || ''}
                className={'min-h-[126px]'}
                description={errors.instructions}
              />
            ),
          },
        ]}
        additionalInfo={
          <HelpCenterLink
            link={getCashOnDeliveryHelpPageLink(user?.dashboardLocale)}
            integration={getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery)}
          />
        }
        onCreate={onCreate}
        requiredFields={['instructions']}
      />
    </>
  )
}

export default CashOnDeliveryCreateModal
